import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { GroundSidePanelDetails } from "./GroundSidePanelDetails";

export interface GroundTransportSidePanelProps {
  groundTransportId: number
  trigger: JSX.Element
  onChange: () => void
}

export const GroundTransportSidePanel = (props: GroundTransportSidePanelProps) => {
  return <DetailSidePanel
    apiCall={() => window.CoreApi.GroundTransport.GetSidePanelData(props.groundTransportId)}
    apiKey="groundTransport"
    entityId={props.groundTransportId}
    title={RESX.GroundTransport.resxGroundTransport}
    footerContent={<>
      <ButtonPrimary href={routes.groundTransport_Detail(props.groundTransportId).absolute} label={RESX.Buttons.DetailView} />
    </>}
    trigger={props.trigger}
  >
    {(data) => <GroundSidePanelDetails
      onChange={props.onChange}
      groundTransportSidePanelData={data}
    />}
  </DetailSidePanel>
};